import React, {useState, useEffect} from 'react';
import GraphView from './GraphView';

/**
 * Le graphique des checkins
 * @param {*} props props
 * @return {JSX}
 */
export default function Graph(props) {
  const [taches, setTaches] = useState([{}]);

  useEffect(() => {
    setTaches(props.taches);
  }, []);

  const onHandleChange = (data) => {
    setTaches([...data]);
  };

  return (
    <div>
      <GraphView data={taches} onHandleChange={onHandleChange} />
    </div>
  );
}
